import { render, staticRenderFns } from "./CreditMemo.vue?vue&type=template&id=4922691e&scoped=true"
import script from "./CreditMemo.vue?vue&type=script&lang=js"
export * from "./CreditMemo.vue?vue&type=script&lang=js"
import style0 from "./CreditMemo.vue?vue&type=style&index=0&id=4922691e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922691e",
  null
  
)

export default component.exports